/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from 'ethers';
import { Provider, TransactionRequest } from '@ethersproject/providers';
import { Contract, ContractFactory, Overrides } from '@ethersproject/contracts';

import type { PetLiquidFlattenTimeAllyPet } from './PetLiquidFlattenTimeAllyPet';

export class PetLiquidFlattenTimeAllyPetFactory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _prepaidEs: string,
    _nrtManager: string,
    overrides?: Overrides
  ): Promise<PetLiquidFlattenTimeAllyPet> {
    return super.deploy(_prepaidEs, _nrtManager, overrides || {}) as Promise<
      PetLiquidFlattenTimeAllyPet
    >;
  }
  getDeployTransaction(
    _prepaidEs: string,
    _nrtManager: string,
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(_prepaidEs, _nrtManager, overrides || {});
  }
  attach(address: string): PetLiquidFlattenTimeAllyPet {
    return super.attach(address) as PetLiquidFlattenTimeAllyPet;
  }
  connect(signer: Signer): PetLiquidFlattenTimeAllyPetFactory {
    return super.connect(signer) as PetLiquidFlattenTimeAllyPetFactory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): PetLiquidFlattenTimeAllyPet {
    return new Contract(address, _abi, signerOrProvider) as PetLiquidFlattenTimeAllyPet;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: 'contract PrepaidEs',
        name: '_prepaidEs',
        type: 'address',
      },
      {
        internalType: 'contract INRTManager',
        name: '_nrtManager',
        type: 'address',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: '_staker',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: '_petId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: '_fromMonthId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: '_toMonthId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: '_withdrawlAmount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'address',
        name: '_withdrawnBy',
        type: 'address',
      },
    ],
    name: 'AnnuityWithdrawl',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: '_staker',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: '_petId',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'address',
        name: '_appointeeAddress',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'bool',
        name: '_appointeeStatus',
        type: 'bool',
      },
    ],
    name: 'AppointeeUpdated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: '_staker',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: '_petId',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'address',
        name: '_appointeeAddress',
        type: 'address',
      },
    ],
    name: 'AppointeeVoted',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: '_staker',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: '_petId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: '_burningAmount',
        type: 'uint256',
      },
    ],
    name: 'BoosterBurn',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: '_staker',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: '_petId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: '_monthId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: '_depositAmount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'address',
        name: '_depositedBy',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'bool',
        name: '_usingPrepaidES',
        type: 'bool',
      },
    ],
    name: 'NewDeposit',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: '_staker',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: '_petId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: '_monthlyCommitmentAmount',
        type: 'uint256',
      },
    ],
    name: 'NewPET',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: '_minimumMonthlyCommitmentAmount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: '_monthlyBenefitFactorPerThousand',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: '_petPlanId',
        type: 'uint256',
      },
    ],
    name: 'NewPETPlan',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: '_staker',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: '_petId',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'address',
        name: '_nomineeAddress',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'bool',
        name: '_nomineeStatus',
        type: 'bool',
      },
    ],
    name: 'NomineeUpdated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'previousOwner',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'OwnershipTransferred',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: '_staker',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: '_petId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: '_powerBoosterId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: '_withdrawlAmount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'address',
        name: '_withdrawnBy',
        type: 'address',
      },
    ],
    name: 'PowerBoosterWithdrawl',
    type: 'event',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_stakerAddress',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: '_petId',
        type: 'uint256',
      },
    ],
    name: 'appointeeVote',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_stakerAddress',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: '_petId',
        type: 'uint256',
      },
    ],
    name: 'calculatePowerBoosterAmount',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_minimumMonthlyCommitmentAmount',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '_monthlyBenefitFactorPerThousand',
        type: 'uint256',
      },
    ],
    name: 'createPETPlan',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'deployer',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'fundsBucket',
    outputs: [
      {
        internalType: 'contract FundsBucket',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_stakerAddress',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: '_petId',
        type: 'uint256',
      },
    ],
    name: 'getDepositMonth',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_stakerAddress',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: '_petId',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '_monthId',
        type: 'uint256',
      },
    ],
    name: 'getMonthlyDepositedAmount',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_stakerAddress',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: '_petId',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '_annuityMonthId',
        type: 'uint256',
      },
    ],
    name: 'getNomineeAllowedTimestamp',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_stakerAddress',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: '_petId',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '_startAnnuityMonthId',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '_endAnnuityMonthId',
        type: 'uint256',
      },
    ],
    name: 'getSumOfMonthlyAnnuity',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'isAdminMode',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_stakerAddress',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: '_petId',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '_depositAmount',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: '_usePrepaidES',
        type: 'bool',
      },
    ],
    name: 'makeDeposit',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_stakerAddress',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: '_petId',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '_totalDepositAmount',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '_frequencyMode',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: '_usePrepaidES',
        type: 'bool',
      },
    ],
    name: 'makeFrequencyModeDeposit',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_stakerAddress',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: '_petId',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '_depositAmount',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: '_usePrepaidES',
        type: 'bool',
      },
      {
        internalType: 'uint256',
        name: '_depositMonth',
        type: 'uint256',
      },
    ],
    name: 'migrateDeposit',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_stakerAddress',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: '_planId',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '_monthlyCommitmentAmount',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '_timestamp',
        type: 'uint256',
      },
    ],
    name: 'migratePET',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'nrtManager',
    outputs: [
      {
        internalType: 'contract INRTManager',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    name: 'petPlans',
    outputs: [
      {
        internalType: 'bool',
        name: 'isPlanActive',
        type: 'bool',
      },
      {
        internalType: 'uint256',
        name: 'minimumMonthlyCommitmentAmount',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'monthlyBenefitFactorPerThousand',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    name: 'pets',
    outputs: [
      {
        internalType: 'uint256',
        name: 'planId',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'monthlyCommitmentAmount',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'initTimestamp',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'lastAnnuityWithdrawlMonthId',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'appointeeVotes',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'numberOfAppointees',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'prepaidEs',
    outputs: [
      {
        internalType: 'contract PrepaidEs',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'renounceAdminMode',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_petId',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: '_appointeeAddress',
        type: 'address',
      },
      {
        internalType: 'bool',
        name: '_newAppointeeStatus',
        type: 'bool',
      },
    ],
    name: 'toogleAppointee',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_petId',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: '_nomineeAddress',
        type: 'address',
      },
      {
        internalType: 'bool',
        name: '_newNomineeStatus',
        type: 'bool',
      },
    ],
    name: 'toogleNominee',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_planId',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: '_newStatus',
        type: 'bool',
      },
    ],
    name: 'updatePlanStatus',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_stakerAddress',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: '_petId',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: '_appointeeAddress',
        type: 'address',
      },
    ],
    name: 'viewAppointation',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_stakerAddress',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: '_petId',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: '_nomineeAddress',
        type: 'address',
      },
    ],
    name: 'viewNomination',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_stakerAddress',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: '_petId',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '_endAnnuityMonthId',
        type: 'uint256',
      },
    ],
    name: 'withdrawAnnuity',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_stakerAddress',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: '_petId',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '_powerBoosterId',
        type: 'uint256',
      },
    ],
    name: 'withdrawPowerBooster',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    stateMutability: 'payable',
    type: 'receive',
  },
];

const _bytecode =
  '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';
